import React from 'react';
import './PetPreform.css';
import pet1 from '../../../imgs/PETSeries.webp';  // capital "S"
import pet2 from '../../../imgs/KFSeries.webp';  // check KFSseries spelling too


const PetPreform = () => {
  return (
    <div className="petf">
      <div className="petf-card">
        <img
          src={pet1}
          alt="Pet Preform 1"
          className="petf-img"data-aos="fade-down"
        />
<p className="description-box">This is the description for Pet Preform 1.</p>
      </div>
      <div className="petf-card">
        <img
          src={pet2}
          alt="Pet Preform 2"
          className="petf-img"data-aos="fade-down"
        />   
        <p className="description-box">This is the description for Pet Preform 1.</p>
   
      </div>
    </div>
  );
};

export default PetPreform;
